// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Tristan",
  middleName: "",
  lastName: "Van",
  message: " An Aspiring Software Engineer",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/tvan04",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/_tristanvan/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/-tristanvan/",
    },

  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  
  imageSize: 375,
  message:
    "Hi! My name is Tristan Van, and I am currently studying computer science at Vanderbilt University. I have a passion for all things tech, and I'm currently exploring the world of full stack development. When I'm not coding, I enjoy working out or discovering new boba tea places.",
  resume: "https://drive.google.com/file/d/1phAVYIYEV-L-XuraYECRMtFvh0eh5n9c/view?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Projects",
  gitHubUsername: "tvan04", //i.e."johnDoe12Gh"
  reposLength: 0,
  specificRepos: ["rollercoaster-ranking", "popularity-predictor", "SELCA", "workout-app", ],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/headshot.jpg"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/headshot.jpg"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "SQL", value: 60 },
    { name: "Data Structures", value: 85 },
    { name: "C/C++", value: 65 },
    { name: "HTML/CSS", value: 55 },
    { name: "R", value: 80 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for any software engineering internship opportunties! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "vantristan04@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      company: 'Capital One',
      role: 'Software Engineer Intern',// Here Add Company Name
      companylogo: require('../assets/img/c1logo3.png'),
      date: 'June 2025 – August 2025',
    },
    {
      company: 'RedForest',
      role: 'UI/UX Developer',// Here Add Company Name
      companylogo: require('../assets/img/redforest.png'),
      date: 'August 2024 - May 2025',
    },
    {
      company: 'Change++',
      role: 'Software Developer',// Here Add Company Name
      companylogo: require('../assets/img/changeplusplus.jpg'),
      date: 'October 2023 – May 2024',
    },
    {
      company: 'HP Inc.',
      role: 'Business Analytics Extern',// Here Add Company Name
      companylogo: require('../assets/img/hp.png'),
      date: 'Feb 2024 – April 2024',
    },
    
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
